import { render, staticRenderFns } from "./Allergy.vue?vue&type=template&id=0af993e0"
import script from "./Allergy.vue?vue&type=script&lang=js"
export * from "./Allergy.vue?vue&type=script&lang=js"
import style0 from "./Allergy.vue?vue&type=style&index=0&id=0af993e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports